import React from "react";
import { useTranslation } from "react-i18next";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ActionMenu from "@/components/ActionMenu";
import { useUserStore } from "@/hooks/useUserStore";
import { Theme } from "@mui/material";
import { PermissionDeniedModal } from "@/components/PermissionDeniedModal/PermissionDeniedModal";

interface ProfileMenuProps {
  handleDelete: () => void;
  theme: Theme;
}

const ProfileMenu: React.FC<ProfileMenuProps> = ({ handleDelete, theme }) => {
  const { t } = useTranslation("clients");
  const { userHasAccessToCode } = useUserStore();
  const [showPermissionDeniedModal, setShowPermissionDeniedModal] =
    React.useState(false);

  const handlePermissionAlert = () => {
    setShowPermissionDeniedModal(true);
  };

  const actionMenuOptions = [
    {
      icon: <DeleteOutlineIcon />,
      value: t("client_profile.delete"),
      onClick: userHasAccessToCode("PARTICIPANT_EDIT")
        ? handleDelete
        : handlePermissionAlert,
      sx: {
        color: theme.palette.error.main,
      },
    },
  ];

  return (
    <>
      <ActionMenu
        options={actionMenuOptions}
        id="profile-menu"
        data-testid="profile-menu"
        isSquare
        squareSx={{
          color: theme.palette.icon.dark,
          backgroundColor: "#ffffff",
          "&:hover": {
            backgroundColor: theme.palette.surface.main,
          },
          borderRadius: "8px",
          width: "40px",
          height: "40px",
          border: `1px solid ${theme.palette.primary.dark}`,
        }}
      />
      <PermissionDeniedModal
        open={showPermissionDeniedModal}
        onClose={() => setShowPermissionDeniedModal(false)}
      />
    </>
  );
};

export default ProfileMenu;
